import React from 'react'
import Stars from './stars'
import Freeform from './freeform'
import NumericEntry from './numeric-entry'
import PhotoAnswer from './photo-answer'
import Inform from './inform'
import { AnswerItemType } from 'src/model/card'
import Option from './option'
import Signup from './signup'
import Stripe from './stripe-payment'
import ResultCard from './result-card'
import ScoreCard from './score'
import SertifierCard from './sertifier'
import ProtectionCard from './protection'
import ResultStandart from './result-standart'
import QuestionAi from './ai'
import Badge from './badge'

/**
 *
 * @param {*} props
 */
const AnswerTypeFactory = props => {
  const { type, id } = props

  switch (type) {
    case AnswerItemType.INFORM:
      return <Inform key={id} {...props} />
    case AnswerItemType.TESTINGSINGLECHOICE:
      return <Option key={id} {...props} />
    case AnswerItemType.TESTINGMULTIPLECHOICE:
      return <Option key={id} {...props} />
    case AnswerItemType.SURVEYSINGLECHOICE:
      return <Option key={id} {...props} />
    case AnswerItemType.SURVEYMULTIPLECHOICE:
      return <Option key={id} {...props} />
    case AnswerItemType.SURVEYFREEFORM:
      return <Freeform key={id} {...props} />
    case AnswerItemType.SURVEYINPUT:
      return <PhotoAnswer key={id} {...props} />
    case AnswerItemType.SURVEYSTARS:
      return <Stars key={id} {...props} />
    case AnswerItemType.SURVEYNUMERICENTRY:
      return <NumericEntry key={id} {...props} />
    case AnswerItemType.SIGNUP:
      return <Signup key={id} {...props} />
    case AnswerItemType.STRIPEPAYMENT:
      return <Stripe key={id} {...props} />
    case AnswerItemType.RESULT:
      return <ResultCard key={id} {...props} />
    case AnswerItemType.SCORECARD:
      return <ScoreCard key={id} {...props} />
    case AnswerItemType.SERTIFIERCARD:
      return <SertifierCard key={id} {...props} />
    case AnswerItemType.PROTECTIONCARD:
      return <ProtectionCard key={id} {...props} />
    case AnswerItemType.RESULTDEFAULT:
      return <ResultStandart key={id} {...props} />
    case AnswerItemType.AI:
      return <QuestionAi key={id} {...props} />
    case AnswerItemType.BADGE:
      return <Badge key={id} {...props} />
    default:
      return ''
  }
}

export default AnswerTypeFactory
